import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import style from "./PatientProfile.module.sass";
import { callApi } from "../../../helpers";
import Button from "../../Button/Button";

function PatientProfile(props) {
  const { patientTable } = props;

  const onSendResultSuccess = (target) => {
    target.setAttribute("disabled", true);
    target.classList.remove("clickable");
    target.innerHTML = "✓";
  };

  const onClickSendResult = (url, e) => {
    const target = e.target;
    e.preventDefault();
    e.stopPropagation();
    callApi(url, "POST", "", () => onSendResultSuccess(target));
  };

  const onClickArchivePatient = () => {
    const url = patientTable.active ? patientTable.archiveUrl : patientTable.unarchiveUrl;
    callApi(url, "POST", "", () => window.location.reload(false));
  };

  return (
    <div className={`${style.PatientProfile}`}>
      {patientTable.table.map((item) => {
        // do not show autogenarated email address
        if (item.key.toLowerCase() === "email" && item.value?.includes("@nomail.no"))
          return null;

        return item.key ? (
          <div className={`${style.property}`} key={item.key}>
            <div className={`${style.propertyTitle} ${item.keepTextCase ? style.KeepTextCase : ''}`}>{item.key}</div>
            <div className={`${style.value}`}>{item.value}</div>
          </div>
        ) : null;
      })}

      <div className={style.actions}>
        <div className={style.actionRow}>
          <Button
            karyBtn
            href={patientTable.editUrl}
          >
            {patientTable.editText}
          </Button>

          <Button
            karyBtn
            onClick={(e) => onClickArchivePatient()}
          >
            {patientTable.active ? patientTable.archivePatientButtonText : patientTable.unarchivePatientButtonText}
          </Button>
        </div>
        <div className={style.actionRow}>
          <Button
            karyBtn
            kariBtnGreenOver
            onClick={(e) => onClickSendResult(patientTable.sendDataPathAll, e)}
          >
            {patientTable.textDownloadAll}
          </Button>

          <Button
            karyBtn
            kariBtnGreenOver
            href={patientTable.educationalVideoUrl}
          >
            {patientTable.educationalVideoButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}

PatientProfile.propTypes = {};

PatientProfile.defaultProps = {};

export default PatientProfile;
